import React from 'react';
import { AllInclusivePush } from 'Components/widgets/all-inclusive-push/AllInclusivePush';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
type Props = {
  id?: string;
  items: Array<{
    label?: string;
    link?: string;
    mediaUrl: string;
  }>;
  lastItem: {
    icon: string;
    label: string;
    link?: string;
    mediaAlt: string;
  };
  title?: string;
};
export const AllInclusivePushLine = ({ id, lastItem = {}, items = [], title }: Props) => {
  if (!items.length) {
    return null;
  }

  return (
    <SiteContainer className="Line" data-testid="allInclusive" id={id}>
      <LineTitle>{title}</LineTitle>
      <AllInclusivePush
        items={[
          ...items.map((item) => ({
            image: {
              alt: '',
              src: item.mediaUrl,
            },
            label: item.label,
            link: {
              url: item.link,
            },
          })),
          {
            icon: {
              alt: lastItem.mediaAlt,
              name: lastItem.icon,
            },
            label: lastItem.label,
            link: {
              url: lastItem.link,
            },
          },
        ]}
      />
    </SiteContainer>
  );
};
